import { Reveal, SectionTag, SectionHeading } from "./Reveal";
import { ASSETS } from "../lib/site";

const FOUNDERS = [
  {
    name: "Anup",
    role: "Co-Founder & CEO",
    img: ASSETS.founderAnup,
    cardTestId: "leadership-founder-anup-card",
    imgTestId: "leadership-anup-photo-img",
  },
  {
    name: "Aishwarya",
    role: "Co-Founder & Business Growth Strategist",
    img: ASSETS.founderAishwarya,
    cardTestId: "leadership-founder-aishwarya-card",
    imgTestId: "leadership-aishwarya-photo-img",
  },
];

const Leadership = () => (
  <section id="leadership" className="bg-white py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <SectionTag index="07" label="Leadership" testId="leadership-section-tag" />
      <div className="mt-6 flex flex-col justify-between gap-6 lg:flex-row lg:items-end">
        <div className="max-w-2xl">
          <SectionHeading>The people behind the precision</SectionHeading>
        </div>
        <Reveal delay={0.15}>
          <p className="max-w-sm text-sm italic leading-relaxed text-white0">
            "Empowering promotional products distributors with round-the-clock precision
            art and operational velocity."
          </p>
        </Reveal>
      </div>

      <div className="mt-16 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:max-w-4xl">
        {FOUNDERS.map((f, i) => (
          <Reveal key={f.name} delay={i * 0.12}>
            <div
              data-testid={f.cardTestId}
              className="group relative overflow-hidden rounded-2xl border border-slate-200 bg-white transition-all duration-500 hover:-translate-y-1.5 hover:border-[#6DC8F0]/40"
            >
              <div className="relative aspect-[4/4.4] overflow-hidden">
                <img
                  src={f.img}
                  alt={`${f.name}, ${f.role} at Artwork360`}
                  data-testid={f.imgTestId}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent" />
              </div>
              <div className="absolute inset-x-0 bottom-0 p-7">
                <p className="font-display text-xl font-bold text-white">{f.name}</p>
                <p className="mt-1 font-mono2 text-[10px] uppercase tracking-[0.22em] text-[#6DC8F0]">
                  {f.role}
                </p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2}>
        <div
          data-testid="leadership-team-photo-card"
          className="group relative mt-6 overflow-hidden rounded-2xl border border-slate-200 lg:max-w-4xl"
        >
          <div className="relative aspect-[16/8] overflow-hidden">
            <img
              src={ASSETS.teamPhoto}
              alt="The extended Artwork360 team"
              data-testid="leadership-team-photo-img"
              loading="lazy"
              className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#07090E]/90 via-transparent to-transparent" />
          </div>
          <div className="absolute inset-x-0 bottom-0 p-7">
            <p className="font-display text-lg font-bold text-white">Our extended team</p>
            <p className="mt-1 font-mono2 text-[10px] uppercase tracking-[0.22em] text-[#6DC8F0]">
              Order specialists & designers, live in your time zone
            </p>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Leadership;
